// AWS Configuration for OmidNetCare Finance Dashboard
// Values are injected at build time via environment variables
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_80hPohsar',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '4re3pcrj6u4io3gu8ov0u6qjmu',
      loginWith: {
        email: true,
      },
    },
  },
};

export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ||
  'https://wouisaduol.execute-api.us-east-1.amazonaws.com/prod';
